import { cx } from '@shared/lib/cx'
import { formatMoney } from '@shared/lib/format/currency'
import { MoneyValue } from '../MoneyValue/MoneyValue'
import type { MoneyValueProps } from '../MoneyValue/MoneyValue'
import {
  container,
  maxSizeProperty,
  minSizeProperty,
  moneyValueLengthProperty,
  value,
} from './FitMoneyValue.css'

export type FitMoneyValueProps = {
  amount: string
  currency: string
  maxSize: number
  minSize: number
  fractionSize: NonNullable<MoneyValueProps['fractionSize']>
  className?: string
}

export function FitMoneyValue({
  amount,
  currency,
  maxSize,
  minSize,
  fractionSize,
  className,
}: FitMoneyValueProps) {
  const formattedAmount = formatMoney(amount, currency)

  return (
    <div
      className={cx(container, className)}
      style={{
        [maxSizeProperty]: `${maxSize}px`,
        [minSizeProperty]: `${minSize}px`,
      }}
    >
      <span
        className={value}
        style={{ [moneyValueLengthProperty]: formattedAmount.length }}
        title={formattedAmount}
      >
        <MoneyValue amount={amount} currency={currency} size="fluid" fractionSize={fractionSize} />
      </span>
    </div>
  )
}
